// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"4890cfa3","462":"4de38397","470":"24573320","659":"6c2c9811","753":"b9a4adeb","787":"8f25e82c"}[chunkId] + ".chunk.js";
};